import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { getMainInfoByName } from "../../../backend/info/mainInfo";
import "../Hero/Hero.scss";

const Hero = () => {
  const isMedium = useMediaQuery({query: `(max-width: 1550px)`});
  const isSmall = useMediaQuery({query: `(max-width: 600px)`});
  const breakText = useMediaQuery({query: `(max-width: 850px)`});

  const shiftBigLogo = useMediaQuery({query: `(max-width: 1400px)`});
  const showBigLogo = useMediaQuery({query: `(min-width: 1200px)`});
  const moveBigPhotoLeft = useMediaQuery({query: `(max-width: 900px)`});
  const moveBigPhoto = useMediaQuery({query: `(max-width: 850px)`});
  const nudgePhotoUp = useMediaQuery({query: `(max-width: 600px)`});
  const smallNudgePhotoUp = useMediaQuery({query: `(max-width: 500px)`});
  const isTiny = useMediaQuery({query: `(max-width: 450px)`});
  const isVeryTiny = useMediaQuery({query: `(max-width: 350px)`});

  const [imageOffeset, setImageOffset] = useState("0px");

  useEffect(() => {
    setTimeout(() => {
      setImageOffset("0px");
    }, 100);
  }, []);

  const [scrollY, setScrollY] = useState(0);

  function handleScroll() {
    setScrollY(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollY]);

  return (
    <div className="hero">
      <div className="hero__container" style={styles.heroContainer}>
        <svg className="hero__logo" id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1"
             viewBox="0 0 237.4 283.46">
          <path className="st0"
                d="M0,0l118.7,283.46L237.4,0H0ZM147.23,58.41c.89,0,1.6.72,1.6,1.61s-.72,1.61-1.6,1.61-1.61-.72-1.61-1.61.72-1.61,1.61-1.61ZM118.7,11.85c2.84,0,5.14,2.3,5.14,5.14s-2.3,5.14-5.14,5.14-5.14-2.3-5.14-5.14,2.3-5.14,5.14-5.14ZM123.56,26.45c0,1.1-.89,1.99-1.99,1.99h-5.74c-1.1,0-1.99-.89-1.99-1.99s.89-1.99,1.99-1.99h5.74c1.1,0,1.99.89,1.99,1.99ZM114.62,31.17h8.14c1.1,0,1.99.89,1.99,1.99s-.89,1.99-1.99,1.99h-8.14c-1.1,0-1.99-.89-1.99-1.99s.89-1.99,1.99-1.99ZM113.96,37.88h9.47c1.1,0,1.99.89,1.99,1.99s-.89,1.99-1.99,1.99h-9.47c-1.1,0-1.99-.89-1.99-1.99s.89-1.99,1.99-1.99ZM122.76,48.58h-8.14c-1.1,0-1.99-.89-1.99-1.99s.89-1.99,1.99-1.99h8.14c1.1,0,1.99.89,1.99,1.99s-.89,1.99-1.99,1.99ZM123.56,53.3c0,1.1-.89,1.99-1.99,1.99h-5.74c-1.1,0-1.99-.89-1.99-1.99s.89-1.99,1.99-1.99h5.74c1.1,0,1.99.89,1.99,1.99ZM90.17,58.41c.89,0,1.61.72,1.61,1.61s-.72,1.61-1.61,1.61-1.6-.72-1.6-1.61.72-1.61,1.6-1.61ZM84.18,65.48c0-1.65,1.34-3,3-3s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3ZM90.17,72.54c-.89,0-1.6-.72-1.6-1.61s.72-1.61,1.6-1.61,1.61.72,1.61,1.61-.72,1.61-1.61,1.61ZM91.72,68.37v-5.51h0c8.87,1.47,17.43,1.1,25.68-1.23v8.35c-9.16-2.32-17.87-3.32-25.68-1.61ZM117.76,246.2c-.38-1.06-8-22.35-7.67-31.66.34-9.55,4.47-14.44,3.22-21.18-1.25-6.74-6.21-15.18-4.52-21.52s5.88-13.88,3.73-21.82c-2.16-7.95-4.47-15.58-2.37-23.2,2.1-7.62,2.67-13.8.03-21.35-2.64-7.55-4.4-8.67-2.06-17.1,2.29-8.25,2.99-11.12.69-18.59l8.95,1.99v6.09s0,168.35,0,168.35ZM114.51,60.74v-2.72h8.37v2.72c-2.81-1-5.6-1-8.37,0ZM124.95,104.23c2.56,7.17,4.37,12.53,2.87,18.52-1.49,5.99-4.31,12.51-3.58,20.01.74,7.49,5.65,13.17,2.44,23.55-3.21,10.38-3.14,12.38-1.15,22.98,1.99,10.6,1.18,16.24-1.67,22.87-2.85,6.63-.23,11.82.51,18.14.63,5.41-3.53,13.46-4.74,15.66V71.76l8.8-1.95c.06,1.08.68,13.26-2.19,18.26-3,5.24-3.87,8.98-1.31,16.16ZM120,69.97v-8.35c8.25,2.33,16.82,2.7,25.68,1.23h0v5.51c-7.81-1.71-16.53-.72-25.68,1.61ZM147.23,72.54c-.89,0-1.61-.72-1.61-1.61s.72-1.61,1.61-1.61,1.6.72,1.6,1.61-.72,1.61-1.6,1.61ZM150.23,68.47c-1.65,0-3-1.34-3-3s1.34-3,3-3,3,1.34,3,3-1.34,3-3,3Z"
                fill="white"/>
        </svg>
        <div className="hero__title-wrapp">
          <h1 className="hero__title">
            <span className="hero__title-text-big">210</span>
            <span className="hero__title-text-small">Окремий Штурмовий Полк</span>
          </h1>
          <p className="hero__subtitle">
            штурм народжує перемогу
          </p>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  heroWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--orange)",
    overflow: "hidden",
  },
  heroContainer: {
    width: "var(--main-container-width)",
    margin: "0 auto",
    // overflow: "hidden",
  },
  infoColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: "min(3rem, 7vw)",
    paddingBottom: "min(3rem, 7vw)",
    // justifyContent:"center",
    minHeight: "50rem",
  },
  logoContainer: {
    position: "absolute",
    top: "var(--header-height)",
    left: 0,
    width: "100%",
    overflow: "hidden",
  },
  logoStyle: {
    position: "relative",
    left: "calc(100vw - var(--main-container-margin))",
    height: "calc(50rem - 40px)",
    transform: "translateX(-65%)",
  },
  imageContainer: {
    position: "absolute",
    top: "var(--header-height)",
    left: 0,
    width: "100%",
    overflow: "hidden",
    pointerEvents: "none",
  },
  imageStyle: {
    position: "relative",
    transition: "all 0.5s linear",
  },
  bigNumber: {
    fontWeight: "bold",
    color: "var(--dark-grey)",
  },
  nameText: {
    fontWeight: "bold",
    color: "var(--black)",
    marginBottom: "1rem",
  },
  smallText: {
    color: "var(--dark-grey)",
  },
};

export default Hero;
